import { Input } from 'antd';
import clsx from 'clsx';
import React, { FC, useEffect, useState } from 'react';

interface Props {
  textareaRef: React.RefObject<HTMLTextAreaElement>;
  value: string;
  onChange: (v: string) => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  disabled: boolean | undefined;
}

export const isSecondLineReached = (
  value: string,
  textareaRef: React.RefObject<any>,
  lineHeight = 22,
): boolean => {
  if (!value) return false;

  const textarea = textareaRef.current?.resizableTextArea?.textArea;

  if (!textarea) return false;

  const rows = Math.round(textarea.scrollHeight / lineHeight);

  return rows >= 2;
};

const ChatTextArea: FC<Props> = ({
  textareaRef,
  value,
  onChange,
  handleKeyDown,
  placeholder,
  disabled,
}) => {
  const [fixedWidth, setFixedWidth] = useState<number | null>(null);

  useEffect(() => {
    const textarea = (textareaRef.current as any)?.resizableTextArea?.textArea;

    if (textarea && fixedWidth === null) {
      setFixedWidth(textarea.offsetWidth);
    }
  }, [textareaRef, fixedWidth]);
  return (
    <Input.TextArea
      ref={textareaRef}
      name='promptGlobal'
      id='promptGlobal'
      value={value}
      autoSize={{ minRows: 1, maxRows: 5 }}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      disabled={disabled}
      style={{
        width: fixedWidth ? `${fixedWidth}px` : undefined, // 🔒 width locked
        background: 'transparent',
        border: 'none',
        boxShadow: 'none',
        outline: 'none',
        resize: 'none',
        maxHeight: 120,
        overflowY: 'auto',
      }}
      className={clsx(
        'bg-transparent border-none resize-none',
        'text-sm text-white placeholder:text-grayZl-600',
        'leading-[22px]',
        'scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-700 scrollbar-track-rounded-lg p-0 ',
        ' no-scrollbar',
      )}
    />
  );
};

export default ChatTextArea;
